import { Button, Flex } from '@chakra-ui/react'
import { GCPRStatus } from '@eapproval/offer-shared'

import ApproverSlotActionButton from '@/features/offers/offer-detail/components/ApproverSlotActionButton'

const GCPRSubmissionActionButtons = ({
  canEditGCPRSubmission,
  replySlots,
  submissionStatus,
  onSubmit,
  onDeleteDraft,
  onResubmit,
  onArchive,
  onSelectReply,
  canDoGCPRApproval,
  submissionContainActionRequiredApproverDetail,
  onApprove,
  onReject,
  showDeleteDraftInstead = false,
  inviteSlots,
  onSelectInvite,
}) => {
  return (
    <Flex gap="3">
      {canEditGCPRSubmission && submissionStatus === GCPRStatus.DRAFT && (
        <>
          <Button colorScheme="green" onClick={onSubmit}>
            Submit PR
          </Button>
        </>
      )}

      {canEditGCPRSubmission && submissionStatus === GCPRStatus.REJECTED && (
        <Button colorScheme="green" onClick={onResubmit}>
          Resubmit PR
        </Button>
      )}

      {canEditGCPRSubmission &&
        [GCPRStatus.DRAFT, GCPRStatus.REJECTED].includes(submissionStatus) &&
        showDeleteDraftInstead && (
          <Button colorScheme="red" onClick={onDeleteDraft}>
            Delete Draft
          </Button>
        )}
      {canEditGCPRSubmission &&
        [GCPRStatus.DRAFT, GCPRStatus.REJECTED].includes(submissionStatus) &&
        !showDeleteDraftInstead && (
          <Button colorScheme="red" onClick={onArchive}>
            Archive
          </Button>
        )}

      {canDoGCPRApproval && submissionContainActionRequiredApproverDetail && (
        <>
          <Button colorScheme="green" onClick={onApprove}>
            Approve PR
          </Button>
          <Button colorScheme="red" onClick={onReject}>
            Reject PR
          </Button>
          <ApproverSlotActionButton label="Invite" colorScheme="teal" slots={inviteSlots} onSelect={onSelectInvite} />
        </>
      )}

      <ApproverSlotActionButton label="Reply PR" colorScheme="green" slots={replySlots} onSelect={onSelectReply} />
    </Flex>
  )
}

export default GCPRSubmissionActionButtons
